/* unplugin-vue-components disabled */import { render } from "./Index.vue?vue&type=template&id=6c2814ad&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6c2814ad&lang=css"
import "./Index.vue?vue&type=style&index=1&id=6c2814ad&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2814ad"]])

export default __exports__